// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__1c6gv","active":"Link_active__3IfvM"};